export const supplierActionsTypes = {
  GET_SUPPLIERS: 'GET_SUPPLIERS',
  GET_SUPPLIERS_EXITO: 'GET_SUPPLIERS_EXITO',
  GET_SUPPLIERS_ERRROR: 'GET_SUPPLIERS_ERROR'
}
